import { render } from "./Avatar.vue?vue&type=template&id=54408318&scoped=true&ts=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=54408318&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54408318"]])

export default __exports__